export default __webpack_public_path__ + "static/media/IMG-20250105-WA0011.b1b8e89f.jpg";